import moment from 'moment';

class ReportStatementsCtrl {

    static get $inject() {
        return ['$q', 'ModalService', '$scope', '$filter', 'CommissionService', 'UserService', '$stateParams', '$state'];
    }

    constructor($q, ModalService, $scope, $filter, CommissionService, UserService, $stateParams, $state) {

        this.$state = $state;
        this.ModalService = ModalService;
        this.CommissionService = CommissionService;
        this.errorRetrieveData = false;

        this.changingYear = true;
        this.changingStatement = true;
        this.loading = true;
        this.error = this.error.bind(this);

        this.isNegative = (value) => value.amount < 0;

        this.calculateTotal = (policies) => {
            if (!policies || policies.length === 0) {
                return null;
            }
            const total = policies.reduce((a, b) => a + b.commission.amount, 0);
            return {...policies[0].commission, amount: total};
        };

        const addYearProperty = () => {
            this.statements.forEach((statement) => {
                statement.year = $filter('date')(new Date(statement.date), 'yyyy');
            });
        };

        const initializeListOfYears = () => {
            this.years = this.statements.reduce((list, {year}) => {
                return list.includes(year) ? list : [...list, year];
            }, []);
            this.selectedYear = this.years[0];
        };

        const loadStatements = (producerCode) => {
            CommissionService.getStatements(producerCode).then((statements) => {
                this.statements = statements;
                if (statements && statements.length > 0) {
                    addYearProperty();
                    initializeListOfYears();
                    this.updateStatementsByYear();
                } else {
                    this.policies = [];
                    this.years = [];
                    this.statements = [];
                    this.loading = false;
                }
            }, this.error);
        };

        this.$onInit = () => {
            this.policyNumber = $stateParams.policyNumber;
            this.termNumber = $stateParams.termNumber;

            UserService.getAvailableProducerCodesForCurrentUser().then((producerCodes) => {
                const producerCode = producerCodes[0].code;
                this.loading = true;
                loadStatements(producerCode);
            }, this.error);
        };
    }

    selectStatementAndUpdatePolicies(statement) {
        this.changingStatement = true;
        this.selectedStatement = statement;
        this.updateStatementPolicies();
    }

    isStatementSelected(statement) {
        return this.selectedStatement === statement;
    }

    updateStatementsByYear() {
        this.changingStatement = true;
        this.changingYear = true;
        this.statementsFiltered = this.statements.filter((statement) => statement.year === this.selectedYear)
            .sort((statement1, statement2) => moment(statement2.date) - moment(statement1.date));
        this.selectedStatement = this.statementsFiltered[0];
        this.updateStatementPolicies(this.selectedStatement);
    }

    updateStatementPoliciesAndYear() {
        this.changingStatement = true;
        this.changingYear = true;
        this.selectedYear = this.selectedStatement.year;
        this.updateStatementPolicies();
    }

    updateStatementPolicies() {
        this.policies = [];
        this.changingYear = false;
        this.CommissionService.getStatementPolicies(this.selectedStatement.statement).then((policies) => {
            this.policies = policies;
            this.totalPolicies = this.calculateTotal(policies);
            this.loading = false;
            this.changingStatement = false;
        }, this.error);
    }

    error() {
        if (!this.errorRetrieveData) {
            this.errorRetrieveData = true;
            this.ModalService.showError('gateway.views.modal.Error', 'gateway.directives.PolicyCommissionsSummaryDirective.Failed to retrieve the data');
        }
    }

}

export default ReportStatementsCtrl;
